import { render, staticRenderFns } from "./IncrementoSalarial.vue?vue&type=template&id=12df2157&scoped=true"
import script from "./IncrementoSalarial.vue?vue&type=script&lang=js"
export * from "./IncrementoSalarial.vue?vue&type=script&lang=js"
import style0 from "./IncrementoSalarial.vue?vue&type=style&index=0&id=12df2157&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df2157",
  null
  
)

export default component.exports